const pad2 = (value) => String(value).padStart(2, "0");

/** dd/mm/yyyy for UI labels — locale-independent. */
export const formatDisplayDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
};

/** Calendar Date → YYYY-MM-DD for the API. */
export const dateToApiDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

export const getPickerDateRange = (from, to) => {
  const fromDate = dateToApiDate(from);
  const toDate = dateToApiDate(to);
  if (!fromDate || !toDate) {
    throw new Error("Invalid calendar date.");
  }
  return { fromDate, toDate };
};

/** dd/mm/yy HH:mm for table cells — locale-independent, no moment. */
export const formatTransactionDateTime = (value) => {
  if (!value) return "-";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  const year = String(date.getFullYear()).slice(-2);
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${year} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

/** Default browse range start: today (paired with toDate = today in Payments). */
export const getDefaultPaymentsFromDate = () => new Date();
